import type { ReactNode, Ref } from 'react';

/**
 * Wrapper de seção da Tela 2 (Pessoas) — header (label + count + ação) + corpo.
 * Convertido do `Section` do mockup (pessoas.app.jsx). A visibilidade por
 * capability é decidida pelo orquestrador (PessoaDetailPage), não aqui.
 */
export function PersonSection({
  id,
  label,
  count,
  action,
  children,
  sectionRef,
}: {
  id: string;
  label: string;
  count?: string | number;
  action?: ReactNode;
  children: ReactNode;
  sectionRef?: Ref<HTMLElement>;
}): JSX.Element {
  return (
    <section className="person-section" data-section={id} ref={sectionRef}>
      <header className="person-section__head">
        <span className="person-section__label">{label}</span>
        {count !== undefined && <span className="person-section__count">({count})</span>}
        {action !== undefined && <span className="person-section__action">{action}</span>}
      </header>
      {children}
    </section>
  );
}
